import { Identifiable, Planzone, Resource, ResourceTypes } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedPlanzoneResource, Linker } from "../linkers/types";

function saveVirtualResourceInPlanzone(httpClient: HttpClient, linker: Linker) {
  return (planzone: Identifiable<Planzone>, resource: Resource) =>
    httpClient
      .sendHttpRequest<Identifiable<LinkedPlanzoneResource>>({
        endpoint: `/resources`,
        method: HttpMethods.POST,
        data: {
          name: resource.name,
          description: resource.description,
          type: ResourceTypes.VIRTUAL,
          profession: resource.profession,
          planzone: `planzones/${planzone.uuid}`,
          ...(resource.role && { role: `roles/${resource.role.uuid}` }),
        },
      })
      .then(linker.linkResource);
}

export { saveVirtualResourceInPlanzone };
